import React from 'react';
import { Confirmation } from './common';

const CancelAndConfirmDialog = props => {
  const {
    title,
    message,
    confirmButtonText,
    cancelButtonText,
    isNegative,
    isSubmitting,
    onCancel,
    onConfirm,
    effectiveButtonClassName,
    multilineText = false,
  } = props.dialog || {};

  return (
    <Confirmation
      visible={true}
      title={title}
      message={message}
      confirmButtonText={confirmButtonText}
      cancelButtonText={cancelButtonText}
      isNegative={isNegative}
      isSubmitting={isSubmitting}
      onCancel={onCancel}
      onConfirm={onConfirm}
      effectiveButtonClassName={effectiveButtonClassName}
      multilineText={multilineText}
    />
  );
};

export { CancelAndConfirmDialog };



// WEBPACK FOOTER //
// ./src/components/modals/CancelAndConfirmDialog.jsx